import { jsx as _jsx } from "react/jsx-runtime";
import { Typography, useMediaQuery, useTheme } from "@mui/material";
import { useEffect } from "react";
import { ItemCardSlider } from "../../../../Shared/components/CardLayout/ItemCardSlider";
import { ItemCard } from "../../../../Shared/components/ItemCard/ItemCard";
import { ItemCardType } from "../../../../Shared/components/ItemCard/itemCardUtils";
import { usePriceFormat } from "../../../../Shared/hooks/usePriceFormat/usePriceFormat";
import { product_default_image } from "../../../../Shared/utils/constants";
import { RecipeIngredientReplacementMode, RecipeSelectionType } from "../../../OrderFlowProvider/OrderFlowTypes";
import { useProduct } from "./useProduct";
/**
 * Product - Renders the Product module: A list of products in either a grid or slider with a header.
 * @param moduleConfig
 * @returns Product Module
 */
export const Product = ({ sequenceNumber }) => {
    const { screenXS, screenSM, screenMD, screenLG, isGridLayout, gridSpacing, productsToRender, paperSettings, baseImageUrl, isSubscription, isEditFlow, headerText, dayOfWeek, ReconcileProducts, HandleProductIncrement, HandleProductDecrement, HandleRenewSwitch, CenterCards, enableCustomerSorting, isCustomizeModalOpen, setIsCustomizeModalOpen, } = useProduct(sequenceNumber);
    // ensure only products for configured day filter are in cart
    // and that products can only be renewing if order is subscription
    useEffect(() => {
        ReconcileProducts();
    }, [dayOfWeek, isSubscription]);
    const theme = useTheme();
    const { formatPrice } = usePriceFormat();
    const tabletAndAbove = useMediaQuery(theme.breakpoints.up("md"), { noSsr: true });
    const cardsToRender = productsToRender === null || productsToRender === void 0 ? void 0 : productsToRender.map((product) => {
        const itemPriceObject = formatPrice({ displayPriceOverride: product.productPrice });
        if (product.productImages.length < 1) {
            product.productImages.push(product_default_image);
        }
        const cardProps = {
            itemImageUrls: product.productImages,
            itemName: product.productName,
            itemDescription: product.productDescription,
            imageBaseUrl: baseImageUrl,
            itemPriceObject: itemPriceObject,
            itemSalePrice: product.hasSale ? product.salePriceDisplay : undefined,
            quantity: product.quantity,
            isAddDisabled: false,
            isMinusDisabled: false,
            isCustomizeDisabled: false,
            handleQuantityIncrement: () => HandleProductIncrement(product.productId, product.DayOfWeek),
            handleQuantityDecrement: () => HandleProductDecrement(product.productId, product.DayOfWeek),
            handleRenewSwitch: isSubscription && !isEditFlow ? () => HandleRenewSwitch(product.productId, product.DayOfWeek) : undefined,
            isRenewing: product.isRenewing,
            itemChips: [],
            recipeFlags: [],
            recipeSelectionType: RecipeSelectionType.Both,
            itemType: ItemCardType.Product,
            recipeIngredientReplacementMode: RecipeIngredientReplacementMode.DISABLED,
            assignmentCount: 0,
            isCustomizeModalOpen,
            setIsCustomizeModalOpen,
        };
        return _jsx(ItemCard, Object.assign({}, cardProps), product.productId);
    });
    if (!(productsToRender === null || productsToRender === void 0 ? void 0 : productsToRender.length)) {
        return null;
    }
    return (_jsx(ItemCardSlider, { parentSequenceNum: sequenceNumber, paperSetting: paperSettings, gridSpacing: gridSpacing, isGridLayout: isGridLayout || !tabletAndAbove, cardsPerRowXS: screenXS, cardsPerRowSM: screenSM, cardsPerRowMD: screenMD, cardsPerRowLG: screenLG, cardsToRender: cardsToRender, CenterCards: CenterCards, isCollapsible: true, isCollapseDisabled: cardsToRender && cardsToRender.length === 0, text: _jsx(Typography, Object.assign({ variant: "h2", gutterBottom: true, color: "primary" }, { children: headerText })), enableCustomerSorting: enableCustomerSorting, enableSuggestedSorting: false }));
};
